module.exports = __webpack_public_path__ + "img/image17.8dbfb0d9.png";